import {
  ACTIVATE_ANIMATION_SLIDE,
  DISABLED_ANIMATION_SLIDE
} from "../types/animation.types";
import { deepClone } from "../../utils/utils";


const initialState = {
  animSlide: true
};

const reducer = function orderReducer(state = initialState, action) {
  const newState = deepClone(state);
  switch (action.type) {
    case ACTIVATE_ANIMATION_SLIDE:
      newState.animSlide = true;
      return newState;
    case DISABLED_ANIMATION_SLIDE:
      newState.animSlide = false;
      return newState;
    default:
      return newState;
  }
};

export default reducer;
